import React from 'react';
import { ProfileLayout } from '../components/ProfileLayout';
import { Security } from '../components/Security';

export const SecurityPage = () => {
  return (
    <ProfileLayout activeTab="security">
      <Security />
    </ProfileLayout>
  );
};
